import { Button as AntButton, ButtonProps } from "antd";

type Props = ButtonProps & {};

export const Button = (props: Props): JSX.Element => <AntButton {...props} />;
